import React, { useContext, useRef } from 'react';
import { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';
import { planes } from '../../data/cotizadorCrData';

const Resumen = () => {

    const { poliza } = useContext(CotizadorCRDataContext);

    const resText = useRef(null);
    const refResumen=useRef(null);

    const resumeClick = (event) => {
        resText.current.classList.toggle('show');
        refResumen.current.classList.toggle('show');
    }

    const optionsUsd = { style: 'currency', currency: 'USD' };
    const numberFormatUsd = new Intl.NumberFormat('en-US', optionsUsd);

    const optionsCrc = { style: 'currency', currency: 'CRC' };
    const numberFormatCrc = new Intl.NumberFormat('es-CR', optionsCrc);

    const format = (n) => {
        if (n == null)
            n = 0;
        n = Number.parseFloat(n).toFixed(2);
        switch (poliza.planId) {
            case planes.planDolares:
                return numberFormatUsd.format(n);
            case planes.planColones:
                return numberFormatCrc.format(n);
            default:
                return n;
        }

    }

    return (
        <>
            <div className="spin-icon" ref={refResumen}>
                <p onClick={resumeClick} ><strong>RESUMEN</strong><span className="rotate fa fa-caret-left" ></span></p>
            </div>
            <div className="theme-config">
                <div className="theme-config-box" ref={resText}>
                    
                    <div className="skin-settings">

                        <div className="title">
                            <span id="IdPoliza">Resumen</span><br />

                            <span id="tagProducto">
                                Producto: {poliza.planId == planes.planDolares ? 'SEGURO DE AUTOMÓVILES LAFISE PLUS DOLARES' : 'SEGURO DE AUTOMÓVILES LAFISE PLUS COLONES'}
                            </span>
                            <br />
                            {/* <small id="tagPoliza_id">
                            <span className="text-danger">Pendiente de guardar</span>
                        </small> */}

                            <br />
                            <small id="cnpoliza" style={{ fontSize: "12px", color: "darkgreen" }}>
                            </small>
                        </div>

                        <div className="setings-item">

                            <table className="table  table-hover lf-sm-table" id="pdsTable">
                                <tbody>
                                    <tr>
                                        <td style={{ display: "none" }} id="PrimaExonerada" data-value="0.00" className="text-right">0.00</td>
                                        <td style={{ display: "none" }} id="PrimaGravada" data-value="0.00" className="text-right">0.00</td>
                                        <td style={{ display: "none" }} id="mImpuesto2" data-value="0.00" className="text-right">0.00</td>
                                        <td>Prima</td>
                                        <td id="Prima" data-value="0.00" className="text-right">{format(poliza.prima)}</td>
                                    </tr>
                                    <tr>
                                        <td>Descuento</td>
                                        <td id="Descuento" data-value="0.00" className="text-right">{format(poliza.descuento)}</td>
                                    </tr>
                                    <tr className="">
                                        <td>Prima neta</td>
                                        <td id="PrimaNeta" data-value="0.00" className="text-right">{format(poliza.primaNeta)}</td>
                                    </tr>
                                    <tr>
                                        <td>Derecho emisión</td>
                                        <td id="DerechoEmision" data-value="0.00" className="text-right">{format(0)}</td>
                                    </tr>
                                    <tr>
                                        <td>Impuesto</td>
                                        <td id="Impuesto" data-value="0.00" className="text-right">{format(poliza.impuesto)}</td>
                                    </tr>
                                    <tr>
                                        <td>Financiamiento</td>
                                        <td id="Financiamiento" data-value="0.00" className="text-right">{format(poliza.financiamiento)}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Total</strong> </td>
                                        <td id="Total" data-value="0.00" className="text-right"><strong>{format(poliza.total)}</strong></td>
                                    </tr>

                                </tbody>

                            </table>

                        </div>

                        <div className="title">
                            <span>Frecuencia de pago</span><br />
                        </div>

                        <div className="setings-item">
                            <table className="table  table-hover lf-sm-table" id="pdsTable2" style={{ width: "100%" }}>
                                <tbody>
                                    <tr>
                                        <td>Mensual</td>
                                        <td id="Mensual" data-value="0" className="text-right">{format(poliza.primaMensual)}</td>
                                    </tr>
                                    <tr>
                                        <td>Trimestral</td>
                                        <td id="Trimestral" data-value="0" className="text-right">{format(poliza.primaTrimestral)}</td>
                                    </tr>
                                    <tr>
                                        <td>Semestral</td>
                                        <td id="Semestral" data-value="0" className="text-right">{format(poliza.primaSemestral)}</td>
                                    </tr>
                                    <tr>
                                        <td>Anual</td>
                                        <td id="Anual" data-value="0" className="text-right">{format(poliza.primaAnual)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>


                        <div className="title">
                            <span></span><br />
                        </div>
                        <div className="setings-item">
                            <p style={{ textAlign: "justify" }}>La cotización no es oferta ni otorga cobertura de seguro, es solo un cálculo del precio del seguro que podrá variar según el análisis posterior que realice SEGUROS LAFISE</p>
                        </div>

                        <div className="setings-item default-skin">
                            <span className="skin-name ">

                            </span>
                        </div>
                    </div>
                </div>
            </div>

        </>

    );
}

export default Resumen;
